module.exports = __webpack_public_path__ + "static/smokin-poster-b5f62a3a377f93fad04f64ccad6e6e7f.png";